import React from 'react'
import ObservationDetails46 from './46/ObservationDetails'
import ObservationDetails56 from './56/ObservationDetails'
import ObservationDetails57 from './57/ObservationDetails'
import ObservationDetails58 from './58/ObservationDetails'
import ObservationDetails62 from './62/ObservationDetails'

const ObservationDetails = (props) => {

  return (
    <>
      {parseInt(process.env.REACT_APP_PROJECTID) === 46 ? <ObservationDetails46 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 56 ? <ObservationDetails56 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 57 ? <ObservationDetails57 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 58 ? <ObservationDetails58 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 62 ? <ObservationDetails62 {...props}/> : null }
    </>
  )
}

export default ObservationDetails
